module.exports = __webpack_public_path__ + "img/caution.2582a809.png";